export default __webpack_public_path__ + "static/media/jquery-mobile.10250b6a.svg";